import { type IEmbedMagnifiedGraphics } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function MagnifiedGraphics ({
  desktop,
  mobile,
}: IEmbedMagnifiedGraphics) {
  if (desktop && mobile) {
    const srcSet = [desktop[0], `${mobile[0]} 2x`].join(', ');

    return (
      <figure className={styles['uom-image']}>
        <picture className={styles['uom-image__picture']}>
          <img className={styles['uom-image__img']} src={desktop[0]} srcSet={srcSet} />
        </picture>
      </figure>
    );
  }

  return null;
}
